import React, { useEffect, useState } from "react";
import { IVacanciesData } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";

interface Props {
  vacancies: IVacanciesData[];
  selectedVacancies: string;
  setSelectedVacancies: React.Dispatch<React.SetStateAction<string>>;
  openSidebar: boolean;
  setOpenSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

const AcademicSidebar = ({
  vacancies,
  selectedVacancies,
  setSelectedVacancies,
  openSidebar,
  setOpenSidebar,
}: Props) => {
  const mobile = useMobile();
  const tab = useTab();
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  useEffect(() => {
    const matchedProgram = vacancies.find(
      (item) =>
        item.adv_code.toLowerCase() ===
        decodeURIComponent(selectedVacancies).toLowerCase(),
    );

    if (matchedProgram) {
      setOpenMenu(matchedProgram.adv_code);
    }
  }, [vacancies, selectedVacancies]);

  return (
    <div
      className={`col-lg-3 sidebar_mobile_wrapper ${
        openSidebar ? "sidebar_mobile_open" : ""
      }`}
    >
      <div className="sidebar_menu">
        {(mobile || tab) && (
          <div className="sidebar_mobile_header">
            <button
              className="sidebar_close_btn"
              onClick={() => setOpenSidebar(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        )}
        <h2
          className={`${mobile || tab ? "td_fs_36" : "td_fs_48"}`}
          style={
            mobile || tab
              ? {
                  width: "90%",
                }
              : {}
          }
        >
          Academic Vacancies
        </h2>

        <div className="sidebar_line" />

        {vacancies.map((item, index) => {
          const isOpen = openMenu === item.adv_code;

          return (
            <div key={index} className="sidebar_item">
              <div
                className={`sidebar_heading ${isOpen ? "sidebar_active" : ""}`}
                onClick={() => {
                  setOpenMenu(item.adv_code);
                  setSelectedVacancies(item.adv_code);
                  if (mobile || tab) setOpenSidebar(false);
                }}
              >
                <div className="sidebar_heading_left">
                  <h6>
                    <span style={{ fontSize: "12px" }}>{item.adv_code}</span>{" "}
                    {item.position}
                  </h6>
                  {/* <i
                    className={`fa-solid fa-chevron-down sidebar_icon ${
                      isOpen
                        ? `rotate_icon ${!mobile && "ps-2"}`
                        : `${!mobile && "pe-2"}`
                    }`}
                  /> */}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AcademicSidebar;
